// Los mensajes sin leer de Radio, al lado de «Radio» en el menú.
//
// Un `ref` suelto y no estado del store por lo mismo que el correo
// (platform/mail/frontend/client/store.js): la entrada del menú se construye al
// cargar la aplicación, antes de que exista ningún store, y el menú solo pinta
// lo que la entrada trae (AppLayout `badgeOf`). El store lo mantiene al día; el
// store arranca en todas las pantallas (lo arranca la capa de la llamada), así
// que el número se mueve aunque nadie tenga Radio abierto.
//
// Sin esto, quien trabaja en otra pantalla del ERP no se enteraba de nada: el
// push no sale mientras la aplicación está delante (attention.isLooking) y el
// número solo se veía dentro de Radio.

import { ref } from 'vue'

export const unreadRadio = ref(0)

/** Lo que cuenta: los hilos donde sigo, sin los silenciados (lo mismo que la lista). */
export function countUnread(threads) {
  let total = 0
  for (const thread of threads ?? []) {
    if (!thread?.me || thread.me.muted) continue
    total += Math.max(0, Number(thread.unread) || 0)
  }
  return total
}
